import React, {Component, useEffect, useState} from "react";
import {
    Header,
    Icon,
    Divider,
    Form,
    Label,
    Container,
    Select,
    Button,
    Segment,
    Message,
    Search
} from 'semantic-ui-react'
import KDatePicker from '../KDatePicker'
import KDropDown from '../KDropDown'
import {requiredField, validateEmail, validateNum} from '../../common/clientValidators'
import {Field, reduxForm, initialize} from 'redux-form'

import moment from "moment/moment";
import {licenseTypes} from "../../common/licenseHelper";
import KSearch from "../KSearch";
import _ from "lodash";

const validate = values => {
    const errors = {}
    if (values.password && values.passwordConfirm) {
        if (values.password !== values.passwordConfirm) errors.password = 'Passwords does not match';
    }
    return errors;
}


const RenderInputField = ({input,  label, meta: { touched, error }, ...rest}) =>
    <Form.Field>
        <label>{label}</label>
        <input {...input} {...rest} />
        {touched && error && <Label  basic color='red' pointing>{error}</Label>}
    </Form.Field>

const RenderSearchField = ({label, placeHolder, onSearchChange, meta: {touched, error}, ...rest}) => {
    return <Form.Field>
        <label>{label}</label>
        <Search placeholder={placeHolder} onSearchChange={onSearchChange} {...rest}></Search>
    </Form.Field>
}




const LicenseAccessForm = ({emails, invalid, error, handleSubmit, onUpdateValidationState, change, initialEmail='', disabledEmail=false}) => {
    const [isLoading, setIsLoading] = useState(false)
    // Quick-set the expire date relative to today.
    const setExpire = (amount, unit) => change('expire_date', moment().add(amount, unit))
    const [results, setResults] = useState([])
    const [value, setValue] = useState(initialEmail)
    const searchEmails = emails.map((email) => ({title: email}))
    const onSearchChange = (e, data) => {
        let value = data.value
        if (value.length === 0) {
            setResults([])
        } else {
            const re = new RegExp(_.escapeRegExp(value), 'i')
            const isMatch = (result) => re.test(result.title)
            const results = _.filter(searchEmails, isMatch);
            setResults(results)

        }
    }
    const onResultSelect = (e, data) => {
        let value = data.result.title
        setValue(value)
    }

    useEffect(() => {
        onUpdateValidationState(invalid)
    }, [invalid])

    return <Form onSubmit={handleSubmit} >

        <Form.Group>
            <Field name='email_user' label='Email' placeHolder={"Search email"}
                   loading={isLoading} onSearchChange={onSearchChange}
                   onResultSelect={onResultSelect} autoComplete="off"  readOnly={disabledEmail}
                   results={results} component={KSearch} width={7} validate={[requiredField, validateEmail]}/>

            <Field name='license_type' label="License type" component={KDropDown} width={5}
                   search selection options={licenseTypes}
                   placeholder='Select licenses' />

            <Field name='num_licenses' label="Number of licenses" component={RenderInputField} validate={[requiredField, validateNum]}
                   placeholder='Num licenses' />

            <Field name='expire_date' label="Expire date" component={KDatePicker}
                   minDate={moment()} validate={[requiredField]} placeholder='Expire date' />

        </Form.Group>

        <Form.Group>
            <Form.Field>
                <label>Quick set expire date:</label>
                <Button.Group size='mini' basic>
                    <Button type='button' onClick={() => setExpire(1, 'months')}>+1 month</Button>
                    <Button type='button' onClick={() => setExpire(3, 'months')}>+3 months</Button>
                    <Button type='button' onClick={() => setExpire(1, 'years')}>+1 year</Button>
                </Button.Group>
            </Form.Field>
        </Form.Group>

        {error && <Message negative header='Action forbidden' content={error}/> }

    </Form>
}


export default reduxForm({
    form: 'licenseAccessForm',
    enableReinitialize : true, // this is needed!!
    //validate

})(LicenseAccessForm);
